/**
 * A mapping of the step values to real category names.
 */
export const categoryMap = {
  demenzerkrankte_person: 'Demenzerkrankte Person',
  betreuende_person: 'Betreuende Person',
  praktische_betreungsaufgaben: 'Praktische Betreuungsaufgaben',
  verhaltensveraenderungen: 'Verhaltensveränderungen',
  gesundheit: 'Gesundheit',
  ressourcen_belastungen: 'Ressourcen und Belastungen',
  finanzen_wohnsituation: 'Finanzen und Wohnsituation',
  zukunft: 'Zukunft',
  abrundung: 'Abrundung des Gesprächs',
  ende: 'Ende'
};
